/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OAuthClientUIConfiguration } from './OAuthClientUIConfiguration';
import {
    OAuthClientUIConfigurationFromJSON,
    OAuthClientUIConfigurationFromJSONTyped,
    OAuthClientUIConfigurationToJSON,
} from './OAuthClientUIConfiguration';

/**
 * 
 * @export
 * @interface GetOauth2UiConfiguration200ResponseAllOf
 */
export interface GetOauth2UiConfiguration200ResponseAllOf {
    /**
     * 
     * @type {OAuthClientUIConfiguration}
     * @memberof GetOauth2UiConfiguration200ResponseAllOf
     */
    result: OAuthClientUIConfiguration;
}

/**
 * Check if a given object implements the GetOauth2UiConfiguration200ResponseAllOf interface.
 */
export function instanceOfGetOauth2UiConfiguration200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetOauth2UiConfiguration200ResponseAllOfFromJSON(json: any): GetOauth2UiConfiguration200ResponseAllOf {
    return GetOauth2UiConfiguration200ResponseAllOfFromJSONTyped(json, false);
}

export function GetOauth2UiConfiguration200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOauth2UiConfiguration200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': OAuthClientUIConfigurationFromJSON(json['result']),
    };
}

export function GetOauth2UiConfiguration200ResponseAllOfToJSON(value?: GetOauth2UiConfiguration200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': OAuthClientUIConfigurationToJSON(value.result),
    };
}

